import {baseUrl} from'../config';

export const messageController ={
    getAllMessages:baseUrl+'/api/message',
} 